<template>
  <div class="col-12">
    <section-title
      class="mt-3"
      content="Firmas del Director"
      :has-line="true"
    />

    <div class="pt-2">
      <div
        v-for="(row, index) of signaturesUpdatedDirector"
        :key="`signaturesprovider-item-${index}`"
        class="result-table"
      >
        <div class="row py-2 mr-md-0">
          <div class="row pt-2 col-md-6 pl-2">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">
                Nombre:
              </div>
              <div class="color-black font-16 bold">
                {{ row.signatoryName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Número de Teléfono</div>
              <div class="color-black font-16 bold">
                {{ row.phone | phone }}
              </div>
            </div>
          </div>
          <div class="row pt-2 col-md-5 pl-4">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.email }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Rol:</div>
              <div class="color-black font-16 bold">
                {{ row.rol }}
              </div>
            </div>
          </div>
          <div class="row pt-2 col-md-1 pl-4">
            <div class="col-md-12">
              <div class="color-black font-16 bold">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-radio-button
                    :ref="`primaryDirectorSigner-${index}`"
                    v-model="row.isDirectorPrimary"
                    custom-error-msg="Firmante es requerido."
                    :error="errors[0]"
                    :is-disabled="false"
                    is-inline
                    :name="`Directorfirmante`"
                    :options="
                      row.id > 0
                        ? [
                            {
                              label: '¿Director Principal?',
                              value: row.isDirectorPrimary ? true : index,
                            },
                          ]
                        : [
                            {
                              label: '¿Director Principal?',
                              value: index,
                            },
                          ]
                    "
                    @input="changePrimaryDirector($event, row)"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import { getSignaturesDirector as _getSignaturesDirector } from '@/services/uspqrp/contract.api';
import CustomRadioButton from 'custom-radio';

export default {
  name: 'SignaturesDirectorr',
  components: {
    SectionTitle,
    CustomRadioButton,
  },
  async mounted() {
    await this.getSignaturesDirector();
  },
  data: () => ({
    data: [],
    model: {
      fullName: null,
      roleName: null,
      email: null,
      phone: null,
      userid: null,
      isDirectorPrimary: null,
    },
    signatures: [],
  }),
  props: {
    primaryDirectorOptions: {
      type: Array,
      default: () => [
        {
          label: '¿Principal?',
          value: true,
        },
      ],
    },
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    companyId: {
      type: Number,
      default: 0,
      required: false,
    },
    schoolId: {
      type: Number,
      default: 0,
      required: false,
    },
    requestServiceTypeId: {
      type: Number,
      default: 0,
      required: false,
    },
    studentSchoolId: {
      type: Number,
      default: 0,
      required: false,
    },
    signaturesUpdatedDirector: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async getSignaturesDirector() {
      this.data = (
        await _getSignaturesDirector(this.studentSchoolId, this.contractId)
      ).data;
    },
    changePrimaryDirector(_event, row) {
      const newSignature = {
        signatoryname: row.signatoryName,
        contractid: this.contractId,
        relationTypeId: null,
        email: row.email,
        phone: row.phone,
        userid: row.userId,
        isPrimary: false,
        isProvider: false,
        check: true,
        roleid: row.roleId,
      };
      this.$emit('update-signatures-director', [newSignature]);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
</style>
